import { render, staticRenderFns } from "./project-group-list.component.vue?vue&type=template&id=c48f12c8&"
import script from "./project-group-list.component.vue?vue&type=script&lang=js&"
export * from "./project-group-list.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports